import React from 'react';
import ErpCard from './ErpCard';
import { ErpDiv } from './ErpHtml';
import { iconFor } from '@/lib/iconRegistry';
import { cn } from '@/lib/utils';

export interface ErpSummaryCardProps {
  title: React.ReactNode;
  value: React.ReactNode;
  icon?: string | React.ReactNode;
  variant?: 'primary' | 'success' | 'danger' | 'warning';
  children?: React.ReactNode;
  className?: string;
  valueClassName?: string;
}

const tones = {
  primary: 'text-primary',
  success: 'text-green-700 dark:text-green-400',
  danger: 'text-destructive',
  warning: 'text-amber-700 dark:text-amber-400',
};

/** Compact KPI presentation shared by list and report screens in LTR and RTL. */
export const ErpSummaryCard = React.memo(function ErpSummaryCard({
  title, value, icon = 'bar-chart', variant = 'primary', children, className, valueClassName,
}: ErpSummaryCardProps) {
  return (
    <ErpCard className={cn('h-full min-w-0 border border-border py-0 ring-0', className)} bodyClass="p-4">
      <ErpDiv data-slot="summary-card" className="flex min-w-0 flex-col items-center gap-1 text-center">
        <ErpDiv data-slot="summary-title" className="flex min-w-0 max-w-full items-center justify-center gap-2 text-center text-sm font-medium text-muted-foreground">
          <ErpDiv aria-hidden="true" className={cn('shrink-0', tones[variant])}>
            {typeof icon === 'string' ? iconFor(icon, 16) : icon}
          </ErpDiv>
          {title}
        </ErpDiv>
        <ErpDiv data-slot="summary-value" className={cn('max-w-full break-words [overflow-wrap:anywhere] text-center text-2xl font-bold tabular-nums', valueClassName)}>{value}</ErpDiv>
        {children}
      </ErpDiv>
    </ErpCard>
  );
});
